import { useSelector } from "react-redux";
import { useState } from "react";
import { TokenEntity } from "../../../../../../entities/ServicesEntities/UserEntities/TokenEntity";
import {
  ASSIGN_OPTIONS,
  INPUTS_PROPS
} from "../../../../../../enums/Enums";
import { commonActions } from "../../../../../../redux/reducers/CommonReducer";
import store from "../../../../../../redux/Store";
import Icons from "../../../../../../resources/icons/Icons";
import Strings from "../../../../../../resources/Strings";
import AssigneFobToggleButtons from "../../../../Buttons/CustomToggleButton/AssigneFobButtons/AssigneFobToggleButtons";
import ScanFobInput from "../../../../Inputs/ScanWithFobsInputs/ScanFobInput";
import classes from "../../WizardForm.module.css";
import * as actionsService from "../../../../../../services/ActionsService/ActionsService";
import ExistingAllocationInputWithoutVerification from "../../../../Inputs/ScanWithFobsInputs/ExistingAllocationInputWithoutVerification";

const AddSingleTokenWithFob = (props) => {
  // Before adding reducer
  // const [showScanFobButton, setShowScanFobButton] = useState(true);
  // const [showFobScannerInput, setShowFobScannerInput] = useState(false);
  // const [showAssigneFobOptions, setShowAssigneFobOptions] = useState(false);
  // const [assigneOption, setAssigneOption] = useState(null);
  // const [showExsistingParkingAllocation, setShowExsistingParkingAllocation] = useState(false);

  // reducer
  const showScanFobButton = useSelector((state) => state.common.showScanFobButton);
  const showFobScannerInput = useSelector((state) => state.common.showFobScannerInput);
  const showAssigneFobOptions = useSelector((state) => state.common.showAssigneFobOptions);
  const assigneOption = useSelector((state) => state.common.assigneOption);
  const showExsistingParkingAllocation = useSelector((state) => state.common.showExsistingParkingAllocation);
  const isShowStep = props?.currentStep <= props?.totalSteps;
  const [hasLocalErrors, setHasLocalErrors] = useState(false);

  // Check if there is already a skip fob when moving steps back (when fob added and value is null), if no default is false
  const [skipFob, setSkipFob] = useState(props?.carUserTokens?.length > 0 && props?.carUserTokens?.[0]?.fob === null);

  // 
  //const [isFobSkipped, setIsFobSkipped] = useState(false); // added  

  const handleChange = (event) => {
    props.handleChange(event);
  };

  const scanNewFob = () => {
    /*
    setShowFobScannerInput(true);
    setShowScanFobButton(false);
    setShowAssigneFobOptions(false);
    setShowExsistingParkingAllocation(false);
    */

    // with reducer
    store.dispatch(commonActions.setShowFobScannerInput(true));
    store.dispatch(commonActions.setShowScanFobButton(false));
    store.dispatch(commonActions.setShowAssigneFobOptions(false));
    store.dispatch(commonActions.setAssigneOption(null)); // added
    store.dispatch(commonActions.setShowExsistingParkingAllocation(false));

    if (props.fromGmt === undefined) {
      props.setIsAddParkingAllocationInProcess(false);
    }
  };


  const handleConfirmScanFob = () => {
    props.handleChange({ ["isStepSubmitted"]: true });
    setSkipFob(false);
    if (props.fob === null || props.fob === "") {
          //props.handleChange({ ["isStepSubmitted"]: true });
          props.setShowStepError(true);
          setHasLocalErrors(false);
          /*
          setShowAssigneFobOptions(false);
          setShowFobScannerInput(true);
          */
          // reducer
          store.dispatch(commonActions.setShowAssigneFobOptions(false));
          store.dispatch(commonActions.setShowFobScannerInput(true));
    } else {
      actionsService.isFobOk(props.fob).then(response => {
        props.setShowStepError(false);
        if(response?.data?.isSuccess){
          setHasLocalErrors(false);
          /*
          setShowAssigneFobOptions(true);
          setShowFobScannerInput(false);
          */

          store.dispatch(commonActions.setShowAssigneFobOptions(true));
          store.dispatch(commonActions.setShowFobScannerInput(false));
        }else{
          setHasLocalErrors(true);
          store.dispatch(commonActions.setShowAssigneFobOptions(false));
          store.dispatch(commonActions.setShowFobScannerInput(true));
        }
      }).catch(err => console.log(err));
    }

    // PREV CODE
    //setShowAssigneFobOptions(true);
    //setShowFobScannerInput(false);
  };

  const handleAssigneOptionChange = (event, selectedValue) => {
    //setAssigneOption(selectedValue);
    let isReset = false;
    // reducer
    store.dispatch(commonActions.setAssigneOption(selectedValue));

    // if null clear carTokens
    if (!selectedValue || selectedValue === null) {
      handleChange({ [INPUTS_PROPS.CAR_USER_TOKEN]: [] });
      props.handleClearAllTokens();
      isReset = true;
    }


    if (selectedValue == ASSIGN_OPTIONS.NEW) {
      //new parking allocation
      props.handleAssignTokenToFob(
        new TokenEntity(
          0,
          props.selectedSite.isOutSourceGarage ? props.fob : null, // null, //props.fob === '' ? null : props.fob, // addeed (before : null)
          `Parking Allocation - ${props.fob} (New)`,
          //props.site,
          props.selectedSite?.id,
          props.userType,
          props.isPaying,
          false
        ),
        skipFob
      );
      /*
      setShowAssigneFobOptions(false);
      setShowScanFobButton(true);
      */

      // reducer
      store.dispatch(commonActions.setShowAssigneFobOptions(false));
      store.dispatch(commonActions.setShowScanFobButton(false));

      if (props.fromGmt === undefined) {
        props.setIsShowSaveChanges(true)
      }

    } else if (selectedValue == ASSIGN_OPTIONS.EXSIST && props.fob) {
      //Exsiting parking allocation
      /*
      setShowExsistingParkingAllocation(true);
      setShowAssigneFobOptions(false);
      */

      // reducer
      store.dispatch(commonActions.setShowExsistingParkingAllocation(true));
      store.dispatch(commonActions.setShowAssigneFobOptions(false));

      if (props.fromGmt === undefined) {
        props.setIsShowSaveChanges(props.occupiedTokens?.length > 0 ? true : false);
      }

    } else if (selectedValue == ASSIGN_OPTIONS.EXSIST) { // added

      store.dispatch(commonActions.setShowExsistingParkingAllocation(true));
      store.dispatch(commonActions.setShowAssigneFobOptions(false));
    } else if (selectedValue == ASSIGN_OPTIONS.NEW && props.isFobSkipped) { // && props.isFobSkipped
      if (props.carUserTokens.length === 0 && !isReset) {
        props.handleAssignTokenToFob(
          new TokenEntity(
            0,
            null, // props.fob === '' ? null : props.fob,
            `Parking Allocation - (New)`,
            //props.site,
            props.selectedSite?.id,
            props.userType,
            props.isPaying,
            false
          )
        );

        store.dispatch(commonActions.setShowAssigneFobOptions(false));
        
        if (props.fromGmt === undefined) {
          props.setIsShowSaveChanges(true);
        }
      }
    }

    // added
    // if (props.occupiedTokens?.length > 0) {
    //   props.setIsCurrentStepValid(true);
    // } else {
    //   props.setIsCurrentStepValid(false);
    // }
  };

  const handleClose = () => {
    /*
    setShowScanFobButton(true);
    setShowFobScannerInput(false);
    setAssigneOption(null);
    */

    // reducer
    store.dispatch(commonActions.setShowScanFobButton(true));
    store.dispatch(commonActions.setShowFobScannerInput(false));
    store.dispatch(commonActions.setAssigneOption(null));

    if (props.fromGmt === undefined) {
      props.setIsAddParkingAllocationInProcess(false); // added
      props.setIsShowSaveChanges(false);
    }

    handleChange({ [INPUTS_PROPS.FOB]: "", ["isStepSubmitted"]: false });
  }
  // added
  const handleSkip = () => {
    // setIsFobSkipped(true);  - prev
    // props.setIsFobSkipped(true);
    /*
    setShowScanFobButton(false);
    setShowFobScannerInput(false);
    setShowAssigneFobOptions(true);
    */
    setSkipFob(true);
    // reducer
    store.dispatch(commonActions.setShowScanFobButton(false));
    store.dispatch(commonActions.setShowFobScannerInput(false));
    store.dispatch(commonActions.setShowAssigneFobOptions(true));

    props.setShowStepError(false);

    handleChange({ [INPUTS_PROPS.FOB]: "" }); // "", null
  };

  const handleDeleteFob = () => {
    /*
    setShowScanFobButton(true);
    setShowAssigneFobOptions(false);
    setShowFobScannerInput(false);
    setShowExsistingParkingAllocation(false);
    setAssigneOption(null);
    */

    // reducer
    store.dispatch(commonActions.setShowScanFobButton(true));
    store.dispatch(commonActions.setShowAssigneFobOptions(false));
    store.dispatch(commonActions.setShowFobScannerInput(false));
    store.dispatch(commonActions.setShowExsistingParkingAllocation(false));
    store.dispatch(commonActions.setAssigneOption(null));

    if (props.fromGmt === undefined) {
      props.setIsShowSaveChanges(false);
      props.setIsAddParkingAllocationInProcess(false); // added
    }

    handleChange({ [INPUTS_PROPS.FOB]: "" });

    // added - clear car user token if fob is skipped
    // if (props.isFobSkipped) {
    //   handleChange({ ["carUserTokens"]: [] });
    // }
  };

  const handleAssignTokenToFob = (token) => {
    /*
    setShowScanFobButton(true);
    setAssigneOption(null);
    */

    store.dispatch(commonActions.setShowScanFobButton(false));
    store.dispatch(commonActions.setShowExsistingParkingAllocation(false));
    store.dispatch(commonActions.setAssigneOption(null));

    props.handleAssignTokenToFob({ ...token?.token, displayValue: `Parking Allocation, (Occupied: ${token?.token.displayValue})` });
    if (props.fromGmt === undefined) {
      props.setIsShowSaveChanges(true)
    }
  };

  return (
    <div className={classes.stepContainer}>
      {showScanFobButton && (
        <button
          onClick={scanNewFob}
          type="button"
          className={classes.addCarButton}
        >
          <img src={Icons.ADD_BUTTON} />
          <span>{Strings.SCAN_NEW_FOB_BUTTON}</span>
        </button>
      )}
      {/* {((!showScanFobButton && assigneOption === ASSIGN_OPTIONS.EXSIST) || showAssigneFobOptions || assigneOption === ASSIGN_OPTIONS.EXSIST) && (
          <div className={classes.switchToolTip}>
          <SwitchInput
            checked={props.isPaying}
            onChange={handleChange}
            leftText={"Non-Paying"}
            rightText={"Paying"}
            id={INPUTS_PROPS.IS_PAYING}
          />
          <CustomTooltip {...props}  tooltipTitle={Strings.TOOLTIP_INFO_TITLE.IS_PAYING} tooltipText={Strings.TOOLTIP_INFO_TEXT.IS_PAYING} />
        </div>
      )} */}
      {/* Scan Fob Input */}
      {showFobScannerInput && (
        <ScanFobInput
          label={Strings.INPUT_LABELS.FOB_SCAN}
          id={INPUTS_PROPS.FOB}
          value={props.fob}
          onChange={handleChange}
          handleClose={handleClose}
          handleSkip={handleSkip}
          isStepSubmitted={props.isStepSubmitted}
          handleConfirmScanFob={handleConfirmScanFob}
          handleError={false}
          //hasError={false}
          //errorMessage=""
          hasError={hasLocalErrors}
          errorMessage={hasLocalErrors ? Strings.INPUT_ERROR_MESSAGES.FOB_ALREADY_EXISTS : ""}
        />
      )}
      {/* Select New/Exsisting Parker */}
      {showAssigneFobOptions && (
        <div>
          <div className={classes.assignOptionsContainer}>
            <AssigneFobToggleButtons
              selectedOption={assigneOption}
              handleChange={handleAssigneOptionChange}
              handleDeleteFob={handleDeleteFob}
              fobId={props.fob}
              //isFobSkipped={isFobSkipped} // added
              isFobSkipped={props.isFobSkipped}
              skipFob={skipFob}
            />
          </div>
        </div>
      )}
      {/* Select From Exsisting Parker */}
      {showExsistingParkingAllocation && (
        <ExistingAllocationInputWithoutVerification
          handleChange={props.handleChange}
          handleDeleteFob={handleDeleteFob}
          fobId={props.fob}
          siteId={props?.selectedSite?.id}
          isPaying={props?.isPaying}
          handleAssignTokenToFob={handleAssignTokenToFob}
          userTypeId={props.userTypeId}
          isFobSkipped={props.isFobSkipped}
          skipFob={skipFob}
          dialingCode={props.dialingCode}
          phoneNumber={props.phoneNumber}
          occupiedTokens={props.occupiedTokens}
          isAddAllocationProcess={props.isAddAllocationProcess}
          userData={props?.userData}
        />

        // <ExsistingParkingAllocationInput
        //   handleChange={props.handleChange}
        //   handleDeleteFob={handleDeleteFob}
        //   fobId={props.fob}
        //   siteId={props?.selectedSite?.id}
        //   isPaying={props?.isPaying}
        //   handleAssignTokenToFob={handleAssignTokenToFob}
        //   userTypeId={props.userTypeId}
        //   isFobSkipped={props.isFobSkipped}
        //   dialingCode={props.dialingCode}
        //   phoneNumber={props.phoneNumber}
        //   occupiedTokens={props.occupiedTokens}
        //   isAddAllocationProcess={props.isAddAllocationProcess}
        //   userData={props?.userData}
        // />
      )}
    </div>
  );
};

export default AddSingleTokenWithFob;
